import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'styles/pages/booking-shell.css';
import Logo from 'assets/brand-logo-compact.svg';
import ChatWidgetLoader from './ChatWidgetLoader';

const BookingNavigation = createContext(null);
export const useBookingNavigation = () => useContext(BookingNavigation);

// Presentation/navigation only. The form owns draft persistence and payment rules.
export default function BookingShell({ children }) {
  const navigate = useNavigate();
  const save = useRef(null);
  const busy = useRef(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const registerSave = useCallback(callback => {
    save.current = callback;
    return () => { if (save.current === callback) save.current = null; };
  }, []);
  const leave = useCallback(async destination => {
    if (busy.current) return;
    busy.current = true;
    setSaving(true);
    setError('');
    try {
      if (save.current && await save.current() !== true) throw new Error('draft_not_saved');
      navigate(destination);
    } catch {
      setError('Kladden kunne ikke gemmes. Dine indtastninger er her stadig. Prøv igen.');
    } finally {
      busy.current = false;
      setSaving(false);
    }
  }, [navigate]);
  const link = (event, destination) => { event.preventDefault(); leave(destination); };
  return (
    <BookingNavigation.Provider value={{ registerSave, leave }}>
      <div className="booking-shell">
        <header className="booking-shell__header">
          <a href="/" onClick={event => link(event, '/')} aria-label="Gem kladde og gå til forsiden">
            <img src={Logo} alt="Flytte og Fragttilbud" />
          </a>
          <button type="button" onClick={() => leave('/')} disabled={saving}>
            {saving ? 'Gemmer…' : 'Gem og afslut'}
          </button>
        </header>
        {error && <p className="booking-shell__error" role="alert">{error}</p>}
        <main className="booking-shell__main">{children}</main>
        <ChatWidgetLoader />
        <footer className="booking-shell__footer">
          <a href="/support" onClick={event => link(event, '/support')}>Brug for hjælp?</a>
          <a href="/terms-of-service" onClick={event => link(event, '/terms-of-service')}>Vilkår</a>
          <a href="/privacy-policy" onClick={event => link(event, '/privacy-policy')}>Privatliv</a>
          <span>Din kladde gemmes undervejs.</span>
        </footer>
      </div>
    </BookingNavigation.Provider>
  );
}
